<template>
  <khrc-navbar/>
<research-fellows-details-component/>
  </template>
  
  <script>
  import KhrcNavbar from "@/components/KhrcNavbar.vue";
  import ResearchFellowsDetailsComponent from '@/components/ResearchFellowsDetailsComponent'
  export default {
    components: {
      KhrcNavbar,
      ResearchFellowsDetailsComponent
    },
  };
  </script>
  
  <style></style>
  